import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { POST_TYPE_, TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import PostsContext from "../../../../context/PostsContext/PostsContext";
import {
  Enable_Disable_Posts,
  Get_Details_Posts,
  DELETE_Posts,
} from "../../../../Apis/postsApi/postsApi";
import Actions from "../../../../layouts/Actions";

const PostsDataTableContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setDialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(PostsContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get Posts Details
   */
  const { mutate: postsDetails, isLoading: isLoadingCompanyDetails } =
    useMutation((postId) => Get_Details_Posts(postId, setFormData, setDialogs));

  const GetPostsDetails = (postId) => {
    postsDetails(postId);
    setOrgId(postId);
    setIsEdit(false);
  };

  /**
   * delete Posts
   */
  const { mutate: postsDelete, isLoading: isLoadingDelete } = useMutation(
    (postId) => DELETE_Posts(postId, refetch)
  );

  const DeletePosts = async (postId) => {
    SweetConfirmation(postsDelete, postId);
  };

  /**
   * enable / disable Company
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Posts(formData, refetch)
  );

  const handlePostsStatusChange = (postId, status) => {
    let formDate = {
      postId: postId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.postId === postId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 120,
      field: "thumbImage",
      headerName: "Thumb Image",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail"
            src={params.row.thumbImage}
            alt=""
            width={100}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "title",
      headerName: "Title",
      renderCell: (params) => (params.row.title ? params.row.title : "--"),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "name",
      headerName: "Language Detail",
      renderCell: (params) =>
        params.row.languageDetail ? params.row.languageDetail?.name : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "religionDetail",
      headerName: "Religion Detail",
      renderCell: (params) =>
        params.row.religionDetail ? params.row.religionDetail?.name : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "type",
      headerName: "type",
      renderCell: (params) =>
        params.row.type ? POST_TYPE_[params.row.type] : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdDetail",
      headerName: "Created Detail",
      renderCell: (params) =>
        params.row.createdDetail ? params.row.createdDetail?.name : "--",
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "isPremium",
      headerName: "Premium",
      renderCell: (params) =>
        params.row.isPremium ? (
          <span style={{ color: "green", fontWeight: "600" }}>Active</span>
        ) : (
          <span style={{ color: "red", fontWeight: "600" }}>In Active</span>
        ),
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "isSameDay",
      headerName: "Same Day",
      renderCell: (params) =>
        params.row.isSameDay ? (
          <span style={{ color: "green", fontWeight: "600" }}>Yes</span>
        ) : (
          <span style={{ color: "red", fontWeight: "600" }}>No</span>
        ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "postDate",
      headerName: "Post Date",
      sortable: false,
      renderCell: (params) =>
        params.row.postDate
          ? moment(params.row.postDate)
              .utcOffset(TIME_ZONE)
              .format("DD MMM, YYYY hh:mm")
          : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "postSendDate",
      headerName: "Post Send Date",
      sortable: false,
      renderCell: (params) =>
        params.row?.postSendDate
          ? moment(params.row?.postSendDate)
              .utcOffset(TIME_ZONE)
              .format("DD MMM, YYYY hh:mm")
          : "--",
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handlePostsStatusChange(params.row.postId, params.row.isActive)
            }
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.postId}
            getDetails={GetPostsDetails}
            deleteDetails={DeletePosts}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingCompanyDetails || isLoadingDelete}
      />
      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.postId}
        addButton={true}
      />
    </Fragment>
  );
};

export default PostsDataTableContainer;
